import { orderBy, where } from 'firebase/firestore';
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { DefaultContext } from '../../../../contexts/default';


import Breadcrumb from '../../../../components/bootstrap/Breadcrumb';
import Button from '../../../../components/bootstrap/Button';
import Card, { CardBody } from '../../../../components/bootstrap/Card';
import SelectEstablishment from '../../../../components/MyCustom/SelectEstablishment';
import TableCustom from '../../../../components/MyCustom/TableCustom';
import ModalRegisterComplement from '../../../../components/modals/Complement/ModalRegister';
import ModalRegisterProducts from '../../../../components/modals/Products/ModalRegister';

import ComplementDB from '../../../../database/wrappers/complement';
import ProductDB from '../../../../database/wrappers/product';
import Money from '../../../../helpers/utils/money/money';


import Page from '../../../../layout/Page/Page';
import PageWrapper from '../../../../layout/PageWrapper/PageWrapper';
import SubHeader, { SubHeaderLeft } from '../../../../layout/SubHeader/SubHeader';

import logo from '../../../../assets/img/logo_uget_black.png';


const ItensNoInsume = () => {
    const { establishment, onShowAlert, settings } = useContext(DefaultContext);

    const [openProductModal, setOpenProductModal] = useState(false);
    const [openComplementModal, setOpenComplementModal] = useState(false);
    const [products, setProducts] = useState([]);
    const [complements, setComplements] = useState([]);
    const [itemSelected, setItemSelected] = useState(null);


    useEffect(() => {
        if (!establishment) {
            setProducts([]);
            setComplements([]);
            return;
        };

        const onSubscribeProducts = new ProductDB(establishment.id).on(
            setProducts,
            orderBy('active', 'desc'),
        );

        const onSubscribeComplements = new ComplementDB(establishment.id).on(
            setComplements,
            orderBy('active', 'desc'),
        );


        return () => {
            onSubscribeProducts();
            onSubscribeComplements();
        };
    }, [establishment]);

    const combinedList = useMemo(() => {
        const allItems = [
            ...products.map(p => ({ ...p, itemType: 'product' })),
            ...complements.map(c => ({ ...c, itemType: 'complement', price: c.price || 0 }))
        ];

        return allItems.filter(item => !item.insumes || item.insumes.length === 0);
    }, [products, complements]);



    const handleCloseModals = useCallback(() => {
        setOpenProductModal(false);
        setOpenComplementModal(false);
    }, []);

    const handleOpenModalEdit = useCallback((item) => {
        if (item.itemType === 'product') {
            const productToEdit = {
                ...item,
                price: item.price.toFixed(2).toString(),
                products: item.products.map(product => ({ ...product, qtd: product.qtd.toFixed(2).toString(), unit_value: product.unit_value.toFixed(2).toString() }))
            };
            setItemSelected(productToEdit);
            setOpenProductModal(true);
        } else {
            setItemSelected(item);
            setOpenComplementModal(true);
        }
    }, []);


    const handleChangeStatus = useCallback((item) => {
        const isProduct = item.itemType === 'product';
        const DB = isProduct ? ProductDB : ComplementDB;
        const itemTypeName = isProduct ? 'Produto' : 'Complemento';

        new DB(establishment.id)
            .update(item.id, { active: !item.active })
            .catch(error => onShowAlert({
                title: 'ERRO!',
                msm: `Não foi possível atualizar o status do ${itemTypeName}`,
                icon: 'Error',
                color: 'danger'
            }));
    }, [establishment, onShowAlert]);



    const rowsRender = useMemo(() => combinedList.map(item => ({
        ...item,
    })), [combinedList]);

    const columns = useMemo(() => ([
        {
            label: 'Imagem',
            field: 'image_url',
            format: row => (
                <>
                    {row.image_url ? (
                        <img src={row.image_url} alt="Imagem" width={54} height={54} />
                    ) : (
                        <img src={logo} alt="Imagem" width={60} height='auto' />
                    )}
                </>
            ),
            noExport: true,
        },
        {
            label: 'Nome',
            field: 'name',
        },
        {
            label: 'Tipo',
            field: 'itemType',
            format: row => (
                <span className={`badge text-capitalize bg-opacity-10 ${row.itemType === 'product' ? 'bg-info text-info-emphasis' : 'bg-secondary text-secondary-emphasis'}`}>
                    {row.itemType === 'product' ? 'Produto' : 'Complemento'}
                </span>
            ),
            formatExport: value => value === 'product' ? 'Produto' : 'Complemento'
        },
        {
            label: 'Preço',
            field: 'price',
            format: row => Money.centsToMaskMoney(row.price),
            isCurrency: true
        },
        {
            label: 'Status',
            field: 'active',
            format: row => (
                <Button isLink color={row.active ? 'success' : 'danger'} icon='Circle' onClick={() => handleChangeStatus(row)} className='text-nowrap'>
                    {row.active ? 'Ativo' : 'Inativo'}
                </Button>
            ),
            formatExport: value => value ? 'Ativo' : 'Inativo'
        },
        {
            label: 'Ações',
            field: 'actions',
            format: row => (
                <div className='w-50 d-flex justify-content-between'>
                    <Button color="light" icon="edit" shadow="sm" hoverShadow="sm" size="sm" onClick={() => handleOpenModalEdit(row)} />
                </div>
            ),
            noExport: true
        },
    ]), [handleChangeStatus, handleOpenModalEdit, settings]);

    return (
        <>
            <PageWrapper title="Produtos e Complementos">
                <SubHeader>
                    <SubHeaderLeft>
                        <Breadcrumb
                            list={[
                                { title: 'Cadastros', to: '#' },
                                { title: 'Itens Sem Insumos', to: '/pdv/itensNoInsume' },
                            ]}
                        />
                    </SubHeaderLeft>
                </SubHeader>
                <Page container='fluid'>
                    <Card>
                        <CardBody className='table-responsive p-5'>
                            <div className='row'>
                                <SelectEstablishment />
                            </div>
                            <TableCustom
                                columns={columns}
                                rows={rowsRender}
                                keyExtractor={item => `${item.itemType}-${item.id}`}
                                fileName={'Itens_Sem_Insumos'}
                            />
                        </CardBody>
                    </Card>
                </Page>
            </PageWrapper>

            <ModalRegisterProducts
                open={openProductModal}
                setIsOpen={setOpenProductModal}
                setIsClose={handleCloseModals}
                productSelected={itemSelected}
            />
            <ModalRegisterComplement
                open={openComplementModal}
                setIsOpen={setOpenComplementModal}
                setIsClose={handleCloseModals}
                complementSelected={itemSelected}
            />
        </>
    );
};

export default ItensNoInsume;